import { Nullable } from 'utils/types';
import { Vulnerability } from '../Vulnerability';

export interface VulnerabilityItem {
  vulnerability: Vulnerability;
  isLoading: boolean;
  error: Nullable<string>;
}

interface VulnerabilityState {
  isLoading: boolean;
  error: Nullable<string>;
  vulnerabilityItems: VulnerabilityItem[];
}
export interface State {
  0: VulnerabilityState;
  1: VulnerabilityState;
}

export interface Action<TPayload = unknown> {
  type: Actions;
  payload: TPayload;
}

export enum Actions {
  SET_APPLICANT_1_VULNERABILITIES_START = 'CM/VULNERABILITIES/APPLICANT/1/SET/START',
  SET_APPLICANT_1_VULNERABILITIES_FINISH = 'CM/VULNERABILITIES/APPLICANT/1/SET/FINISH',
  SET_APPLICANT_1_VULNERABILITIES_ERROR = 'CM/VULNERABILITIES/APPLICANT/1/SET/ERROR',

  SET_APPLICANT_2_VULNERABILITIES_START = 'CM/VULNERABILITIES/APPLICANT/2/SET/START',
  SET_APPLICANT_2_VULNERABILITIES_FINISH = 'CM/VULNERABILITIES/APPLICANT/2/SET/FINISH',
  SET_APPLICANT_2_VULNERABILITIES_ERROR = 'CM/VULNERABILITIES/APPLICANT/2/SET/ERROR',

  ADD_APPLICANT_1_VULNERABILITY_FINISH = 'CM/VULNERABILITIES/APPLICANT/1/ADD/FINISH',
  ADD_APPLICANT_2_VULNERABILITY_FINISH = 'CM/VULNERABILITIES/APPLICANT/2/ADD/FINISH',

  UPDATE_APPLICANT_1_VULNERABILITY_FINISH = 'CM/VULNERABILITIES/APPLICANT/1/UPDATE/FINISH',
  UPDATE_APPLICANT_2_VULNERABILITY_FINISH = 'CM/VULNERABILITIES/APPLICANT/2/UPDATE/FINISH',

  APPLICANT_1_VULNERABILITY_IN_PROGRESS_START = 'CM/VULNERABILITIES/APPLICANT/1/IN_PROGRESS/START',
  APPLICANT_1_VULNERABILITY_IN_PROGRESS_FINISH = 'CM/VULNERABILITIES/APPLICANT/1/IN_PROGRESS/FINISH',

  APPLICANT_2_VULNERABILITY_IN_PROGRESS_START = 'CM/VULNERABILITIES/APPLICANT/2/IN_PROGRESS/START',
  APPLICANT_2_VULNERABILITY_IN_PROGRESS_FINISH = 'CM/VULNERABILITIES/APPLICANT/2/IN_PROGRESS/START',

  DELETE_APPLICANT_1_VULNERABILITY_START = 'CM/VULNERABILITIES/APPLICANT/1/DELETE/START',
  DELETE_APPLICANT_1_VULNERABILITY_ERROR = 'CM/VULNERABILITIES/APPLICANT/1/DELETE/ERROR',
  DELETE_APPLICANT_1_VULNERABILITY_FINISH = 'CM/VULNERABILITIES/APPLICANT/1/DELETE/FINISH',

  DELETE_APPLICANT_2_VULNERABILITY_START = 'CM/VULNERABILITIES/APPLICANT/2/DELETE/START',
  DELETE_APPLICANT_2_VULNERABILITY_ERROR = 'CM/VULNERABILITIES/APPLICANT/2/DELETE/ERROR',
  DELETE_APPLICANT_2_VULNERABILITY_FINISH = 'CM/VULNERABILITIES/APPLICANT/2/DELETE/FINISH',
}

export const createState = (): State => ({
  0: {
    error: null,
    isLoading: false,
    vulnerabilityItems: [],
  },
  1: {
    error: null,
    isLoading: false,
    vulnerabilityItems: [],
  },
});
